import styles from './PageHeader.module.scss';
import { HeaderLeft } from './HeaderLeft';
import { HeaderRight } from './HeaderRight';

interface PageHeaderProps {
  searchComponent?: React.ReactNode;
}

export function PageHeader({ searchComponent }: PageHeaderProps) {
  return (
    <div className={styles.container}>
      <HeaderLeft />
      <HeaderRight searchComponent={searchComponent} />
    </div>
  );
}
